import React from 'react'
import { useHistory } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'
import { DatePicker } from '@material-ui/pickers'
import Refresh from '@material-ui/icons/Refresh'

import Button from 'src/components/sharedComponents/CustomButtons/Button'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import MEITotalImportsCard from 'src/components/reports/reportsBoard/MEIReportsCards/MEITotalImportsCard'

const useStyles = makeStyles(() => ({
  root: {
    '& > *': {
      color: '#fff',
    },
  },
}))

const MEIIndividualsImports = props => {
  const { selectedDate, handleDateChange } = props

  const history = useHistory()
  const classes = useStyles()

  return (
    <>
      <CardTitle
        title="Importaciones movilidad eléctrica individual"
        component={
          <DatePicker
            autoOk
            variant="inline"
            views={['year']}
            className={classes.root}
            value={selectedDate}
            maxDate={new Date()}
            onChange={handleDateChange}
          />
        }
      />
      <Button link onClick={() => history.push('/reports/board')}>
        <Refresh /> Volver al Menú
      </Button>
      <MEITotalImportsCard {...props} />
    </>
  )
}

export default MEIIndividualsImports
